import interact from 'interact.js'
import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MiniBook } from '../../../services/ShelvableBackend/BookArray'
import { NgZone } from '@angular/core'

@Directive({ selector: '[endGhostBook]' })
export class EndGhostBookDirective {
    @Output() onInsertBefore:EventEmitter<{bookToInsertBefore:MiniBook}> = new EventEmitter<{bookToInsertBefore:MiniBook}>();

    constructor(private el: ElementRef, private zone:NgZone) {
        interact(el.nativeElement).dropzone({
            accept: 'book'
        });

        el.nativeElement.insertBookBefore = (book) => {
            this.zone.run(() => {
                this.onInsertBefore.emit({bookToInsertBefore: book });
            });
        };
    }
}



// WEBPACK FOOTER //
// ./web/static/components/book/directives/GhostBook.ts